import UploadLogRow from 'features/PMSLogs/LogRow'
import moment from 'moment'
import { useState } from 'react'

import styles from './DayRow.module.scss'

const UploadLogsDayRow = ({
  logGroup,
  handleDownloadData,
  isAdminMode,
  isEditing,
  selectedRows,
  setSelectedRows
}) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <div>
      <div className={styles.row} onClick={() => setExpanded(!isExpanded)}>
        <div className={styles.date}>{moment(logGroup.date).format('MMM D')}</div>
        <div className={styles.iconCol}>
          <i className={styles.calendarIcon} /> {logGroup.totalRecords}
        </div>
        <div className={styles.iconCol}>
          <i className={styles.userIcon} /> {logGroup.totalSubscribers}
        </div>
        <div className={styles.col} />
        <div className={styles.col}>
          <p className={styles.newText}>NEW {logGroup.totalNewSubscribers}</p>
        </div>
        <div className={styles.col}>
          <p className={styles.existText}>EXIST {logGroup.totalUpdatedSubscribers}</p>
        </div>
        <div className={styles.col}>
          <p className={styles.duplicateText}>DUP {logGroup.totalDuplicateSubscribers}</p>
        </div>
        <div className={styles.col}>
          <p className={styles.invalidText}>INV {logGroup.totalUnUsableSubscribers}</p>
        </div>
        <div className={styles.col}>
          <p className={styles.inprogressText}>
            INP {logGroup.totalInProgressSubscribers}
          </p>
        </div>
        <div className={styles.control}>
          <p>View {logGroup.logs.length} reports</p>
        </div>
      </div>
      {isExpanded &&
        logGroup.logs.map(log => (
          <UploadLogRow
            {...log}
            key={log.id}
            handleDownloadData={handleDownloadData}
            isAdminMode={isAdminMode}
            isEditing={isEditing}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
        ))}
    </div>
  )
}

export default UploadLogsDayRow
